const AppInfo = {

  //デザインのサイズ
  DESIGN_WIDTH: 1334,
  DESIGN_HEIGHT: 750,

  //背景の最大サイズ
  MAX_BG_WIDTH: 1624,
  MAX_BG_HEIGHT: 1024,

  //ノッチ用のオフセット
  OFFSET_X: 80
}

export default AppInfo